import { render, staticRenderFns } from "./ConsulenzaTelematicaEditComponent.vue?vue&type=template&id=45b5f76a&scoped=true"
import script from "./ConsulenzaTelematicaEditComponent.vue?vue&type=script&lang=js"
export * from "./ConsulenzaTelematicaEditComponent.vue?vue&type=script&lang=js"
import style0 from "./ConsulenzaTelematicaEditComponent.vue?vue&type=style&index=0&id=45b5f76a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b5f76a",
  null
  
)

export default component.exports